




























import FormGenerator from './FormGeneration.vue';
import * as InlineEditor from '@lynxerious/ckeditor5-build-mcom/build/ckeditor';
import CKEditor from '@ckeditor/ckeditor5-vue';
export default {
    name: 'editor-dialog',
    props: ['options'],
    components: {
        ckeditor: CKEditor.component
    },
    data() {
    return {
        editor: InlineEditor,
        errors: {},
        content: null,
        active: false,
        confirming: false,
        success: false
    }
    },
    watch: {
        options: function (val) {
            this.active = !!val
            this.content = this.options.content?this.options.content:''
            this.reset()
        }
    },
    methods: {
    reset() {
        this.data = {}
        this.errors = {}
        this.confirming = false
        this.success = false
    },
    close() {
        this.active = false
    },
    async confirm() {
        this.confirming = true
        try {
            await this.options.confirmFn(this.content)
            this.success = true
            setTimeout(() => {
            this.active = false
            }, 1000)
        } catch (err) {
            this.success = false
        } finally {
            this.confirming = false
        }
    }
    }
}
